exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntable {\n    width: 100%;\n}\nthead th {\n    padding: 10px 30px 10px 0px;\n}\ntbody td {\n    padding: 6px 30px 6px 0px;\n    border-bottom: 1px solid rgb(240, 240, 240);\n    border-top: 1px solid rgb(240, 240, 240);\n}\n", ""]);

